import React from "react";
import CurrentRouteComponent from "./CurrentRouteComponent";
import {Env} from "@morningtrain/helpers";
import useRouter from "../hooks/use-router";
import {Operation} from "@morningtrain/resources";
import uniqueId from "lodash/uniqueId";
import useOnNavigateStart from "../hooks/use-on-navigate-start";

function RenderCurrentRoute(props) {

    const router = useRouter();

    const [key, setKey] = React.useState(null);
    const componentNameRef = React.useRef(null);

    const handleRouteChange = (routeName, parameters = {}) => {

        const operation = Operation.fromRoute(routeName);

        const componentName = operation.getEnv('component');
        const namespace = operation.getEnv('namespace');
        const title = operation.getEnv('title');
        const parent = operation.getEnv('parent');

        componentNameRef.current = componentName;

        Env.set('page.route', routeName);
        Env.set('page.title', title);
        Env.set('page.parent', parent);
        Env.set('page.parents', operation.getEnv('parents'));
        Env.set('page.component', componentName);
        Env.set('page.namespace', namespace);
        Env.set('page.path', router.getRoute(routeName).uri);

        setKey(uniqueId(router.route(routeName, parameters)));
    };

    React.useEffect(() => {
        handleRouteChange(router.currentRoute, router.currentParameters);
    }, []);

    useOnNavigateStart(handleRouteChange);

    return (
        <CurrentRouteComponent key={key} component={componentNameRef.current}/>
    );
}

export default RenderCurrentRoute;
